function getColorBrightness(rgbColor) {
  var colorValues = rgbColor.match(/[\d\.]+/g).map(Number);
  return 0.2126 * (colorValues[0] / 255) + 0.7152 * (colorValues[1] / 255) + 0.0722 * (colorValues[2] / 255);
}

function isSimilarToBackground(color) {
  var backgroundColor = 'rgb(255, 255, 255)';

  var colorBrightness = getColorBrightness(color);
  var backgroundColorBrightness = getColorBrightness(backgroundColor);

  return (backgroundColorBrightness / colorBrightness) < 1.5;
}

var SwatchColors = (function() {
  function SwatchColors() {
    this.colors = {'pink': 'rgb(244, 199, 208)','white': 'rgb(248, 248, 248)','black': 'rgb(17, 27, 28)','orange': 'rgb(240, 100, 38)','purple': 'rgb(59, 44, 106)','red': 'rgb(201, 21, 36)','daisy': 'rgb(251, 221, 104)','gold': 'rgb(247, 178, 44)','natural': 'rgb(244, 234, 207)','sand': 'rgb(225, 216, 198)','maroon': 'rgb(102, 29, 48)','cardinal-red': 'rgb(154, 17, 53)','heliconia': 'rgb(233, 45, 124)','azalea': 'rgb(237, 106, 170)','light-pink': 'rgb(244, 205, 224)','royal': 'rgb(0, 78, 153)','navy': 'rgb(19, 32, 59)','carolina-blue': 'rgb(125, 169, 216)','light-blue': 'rgb(169, 210, 237)','irish-green': 'rgb(3, 164, 82)','forest-green': 'rgb(38, 60, 47)','military-green': 'rgb(108, 117, 86)','kiwi': 'rgb(145, 178, 101)','sport-grey': 'rgb(200, 203, 208)','graphite-heather': 'rgb(101, 96, 92)','dark-chocolate': 'rgb(31, 26, 22)','dark-heather': 'rgb(41, 44, 49)','ash': 'rgb(220, 224, 227)','garnet': 'rgb(122, 40, 72)','flower-gray': 'rgb(210, 210, 210)','beige': 'rgb(217, 203, 176)','dark-charcoal-gray': 'rgb(53, 53, 55)','dark-green': 'rgb(40, 65, 57)','khaki-ash': 'rgb(198, 193, 169)','light-gray': 'rgb(209, 211, 210)','navy-blue': 'rgb(45, 51, 73)','oat-gray': 'rgb(229, 226, 218)','water-blue': 'rgb(175, 224, 229)','apricot': 'rgb(227, 208, 181)','light-brown': 'rgb(195, 155, 101)','rose-red': 'rgb(214, 90, 136)','dark-blue': 'rgb(55, 90, 145)',};

    this.images = {};

    this.triggers = ['color','colour',];
  }

  function setSwatchColor(swatch) {
    var swatchId = swatch.getAttribute('swatch-id');

    if (Object.keys(this.colors).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.colors[swatchId]);

      if (isSimilarToBackground(this.colors[swatchId])) swatch.classList.add('is-similar-to-background');
      if (getColorBrightness(this.colors[swatchId]) > 0.5) {
        swatch.style.setProperty('--tick-color', '#000');
      } else {
        swatch.style.setProperty('--tick-color', '#fff');
      }
      swatch.classList.remove('is-blank');
    }

    if (Object.keys(this.images).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.images[swatchId]);
      swatch.classList.add('is-image');
      swatch.classList.remove('is-blank');
    }
  }
  SwatchColors.prototype.setSwatchColor = setSwatchColor;

  return SwatchColors;
}());

window.theme.swatches = new SwatchColors();

function VariantSwatch() {
  return Reflect.construct(HTMLElement, [], this.constructor);
}

VariantSwatch.prototype = Object.create(HTMLElement.prototype);
VariantSwatch.prototype.constructor = VariantSwatch;
Object.setPrototypeOf(VariantSwatch, HTMLElement);

VariantSwatch.prototype.connectedCallback = function() {
  window.theme.swatches.setSwatchColor(this);
};
customElements.define('variant-swatch', VariantSwatch);
